<template>
    <Splide
        v-if="props.team.length"
        :options="splideOptions">
        <SplideSlide
            v-for="(member, i) in props.team"
            :key="member.documentId">
            <div class="team-card tw-relative tw-aspect-square tw-overflow-hidden tw-rounded-4xl tw-bg-cover tw-bg-center tw-bg-no-repeat">
                <img
                    alt=""
                    class="formal-picture tw-relative tw-z-10 tw-h-full tw-w-full tw-object-contain"
                    :src="useMedia(member.image).medium" />
                <img
                    v-if="member.casualImage"
                    alt=""
                    class="casual-picture tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-object-contain"
                    :src="useMedia(member.casualImage).medium" />
                <div class="tw-absolute tw-bottom-3 tw-left-3 tw-right-3 tw-z-10 tw-rounded-xl tw-bg-white tw-bg-opacity-90 tw-px-5 tw-py-4">
                    <h4 class="tw-text-sm tw-font-semibold tw-text-dark">{{ member.name }}</h4>
                    <div class="tw-relative tw-h-8">
                        <p class="formal-job tw-absolute tw-left-0 tw-top-0 tw-text-xs tw-font-light tw-text-dark">{{ member.job }}</p>
                        <p
                            v-if="member.casualJob"
                            class="casual-job tw-absolute tw-left-0 tw-top-0 tw-text-xs tw-font-light tw-text-dark">
                            {{ member.casualJob }}
                        </p>
                    </div>
                </div>
            </div>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';
    import { Splide, SplideSlide } from '@splidejs/vue-splide';

    const props = defineProps<{
        team: {
            id: number;
            documentId: string;
            name: string;
            job: string;
            image: any;
            casualImage: any;
            order: number;
        }[];
    }>();

    const splideOptions = ref({
        type: 'loop',
        perPage: 4,
        perMove: 1,
        gap: '2rem',
        pagination: false,
        arrows: props.team.length > 4,
        autoplay: props.team.length > 4,
        interval: 2000,
        breakpoints: {
            1900: {
                perPage: 3,
                arrows: props.team.length > 3,
                autoplay: props.team.length > 3,
                gap: '1.5rem',
            },
            1000: {
                perPage: 2,
                arrows: props.team.length > 2,
                autoplay: props.team.length > 2,
                gap: '1rem',
            },
            640: {
                perPage: 1,
                arrows: props.team.length > 1,
                autoplay: props.team.length > 1,
                gap: '1rem',
            },
        },
    });
</script>

<style scoped>
    .team-card::before {
        content: '';
        background-image: url('@/assets/gradients/gradient-team-bg.png');
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .formal-picture,
    .casual-picture,
    .formal-job,
    .casual-job {
        transition: opacity 0.3s;
    }

    .formal-picture,
    .formal-job {
        opacity: 1;
    }

    .casual-picture,
    .casual-job {
        opacity: 0;
    }

    .team-card:hover:has(.casual-picture) .formal-picture,
    .team-card:hover:has(.casual-job) .formal-job {
        opacity: 0;
    }

    .team-card:hover .casual-picture,
    .team-card:hover .casual-job {
        opacity: 1;
    }
</style>
